import moment from "moment";

export const required = (value) => (value ? undefined : `required`);

export const email = (value) =>
  /^.*.[^@]@[^@][A-Z0-9-]+\.[A-Z]{2,}$/i.test(value) ? undefined : `err`;

export const url = (value) =>
  /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})).?)(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(
    value
  )
    ? undefined
    : `err`;

export const date = (date) => (moment(date, `L`, true).isValid() ? undefined : `err`);

export const number = (value) =>
  /^(?:-?\d+|-?\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/.test(value) ? undefined : `err`;

export const digits = (err) => (value) => (/\d/.test(value) ? undefined : err);

export const uppercase = (err) => (value) => (/[A-Z]/.test(value) ? undefined : err);

export const allowedSymbols = (array, err) => (value) => {
  if (array === `all`) {
    return /[`~!@#$%^&*()\-_=+[{}\]|;:'",<.>/?€£¥₹]/.test(value) ? undefined : err;
  }
  const replace = `[${array}]`;
  return new RegExp(replace, `g`).test(value) ? undefined : err;
};

export const forbiddenSymbols = (array, err) => (value) => {
  if (array === `none`) {
    return undefined;
  }
  const replace = `[${array}]`;
  return new RegExp(replace, `g`).test(value) ? err : undefined;
};

export const minLength = (min, err) => (value) => (value.length >= min ? undefined : err);

export const maxLength = (max, err) => (value) => (value.length <= max ? undefined : err);

export const length36 = (value) => (value.length === 36 ? undefined : `err`);

export const rangelength = (value, params) =>
  value.length >= params[0] && value.length <= params[1] ? undefined : `err`;

export const min = (value, param) => (value >= param ? undefined : `err`);

export const max = (value, param) => (value <= param ? undefined : `err`);

export const range = (value, param) => (value >= param[0] && value <= param[1] ? undefined : `err`);
